// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.prompts-page {
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.prompts-page .page-header {
  margin-bottom: 1rem;
}

.prompts-page .page-header h1 {
  margin: 0;
  font-size: 1.8rem;
  color: #333;
}

.prompts-page .section-description {
  color: #666;
  margin: 0 0 2rem 0;
  font-size: 0.95rem;
}

.prompts-page .account-selector {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 2rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 8px;
}

.prompts-page .account-selector label {
  font-weight: 500;
  color: #333;
}

.prompts-page .account-selector select {
  flex: 1 1;
  max-width: 400px;
  padding: 0.75rem 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.95rem;
  background: white;
}

.prompts-page .account-selector select:focus {
  outline: none;
  border-color: var(--button-color, #007bff);
}

.prompts-page .error-message {
  background: #f8d7da;
  color: #721c24;
  padding: 1rem;
  border-radius: 4px;
  margin-bottom: 1rem;
}

.prompts-list {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.prompt-card {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.prompt-card-header {
  margin-bottom: 0.5rem;
}

.prompt-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.prompt-card-header h3 {
  margin: 0;
  font-size: 1.1rem;
  color: #333;
}

.prompt-card-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.prompt-card-status {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.operation-key {
  font-family: monospace;
  font-size: 0.8rem;
  background: #e9ecef;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  color: #666;
}

.status-toggle {
  padding: 0.35rem 0.75rem;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
  border: none;
  transition: all 0.2s;
}

.status-toggle.active {
  background: #d4edda;
  color: #155724;
}

.status-toggle.active:hover {
  background: #c3e6cb;
}

.status-toggle.inactive {
  background: #f8d7da;
  color: #721c24;
}

.status-toggle.inactive:hover {
  background: #f5c6cb;
}

.prompt-badge {
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: 500;
  text-transform: uppercase;
}

.prompt-badge.custom {
  background: #cce5ff;
  color: #004085;
}

.prompt-badge.default {
  background: #e9ecef;
  color: #6c757d;
}

.prompt-card.disabled {
  opacity: 0.6;
}

.prompt-card.disabled .prompt-card-header h3 {
  color: #999;
}

.prompt-card-description {
  color: #666;
  font-size: 0.9rem;
  margin: 0 0 1rem 0;
}

.prompt-buttons {
  display: flex;
  gap: 0.5rem;
}

.btn-reset-prompt {
  padding: 0.5rem 1rem;
  background: #fff3cd;
  color: #856404;
  border: 1px solid #ffeeba;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.85rem;
  transition: all 0.2s;
}

.btn-reset-prompt:hover {
  background: #ffe69c;
  border-color: #ffc107;
}

.btn-reset-prompt:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.default-prompt {
  color: #888 !important;
}

.prompt-preview {
  border-top: 1px solid #eee;
  padding-top: 1rem;
}

.prompt-text {
  background: #f8f9fa;
  border-radius: 4px;
  padding: 1rem;
  margin-bottom: 1rem;
  max-height: 300px;
  overflow-y: auto;
}

.prompt-text pre {
  margin: 0;
  white-space: pre-wrap;
  word-wrap: break-word;
  font-size: 0.8rem;
  color: #555;
  font-family: 'Consolas', 'Monaco', monospace;
  line-height: 1.4;
}

.no-prompt {
  color: #999;
  font-style: italic;
}

.btn-edit-prompt {
  padding: 0.5rem 1rem;
  background: #f0f0f0;
  color: #555;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.85rem;
  transition: all 0.2s;
}

.btn-edit-prompt:hover {
  background: #e5e5e5;
  border-color: #ccc;
}

.prompt-editor {
  border-top: 1px solid #eee;
  padding-top: 1rem;
}

.prompt-editor textarea {
  width: 100%;
  padding: 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.85rem;
  font-family: 'Consolas', 'Monaco', monospace;
  line-height: 1.4;
  resize: vertical;
  min-height: 300px;
}

.prompt-editor textarea:focus {
  outline: none;
  border-color: var(--button-color, #007bff);
}

.prompt-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1rem;
}

.prompts-page .btn-primary {
  padding: 0.7rem 1.5rem;
  background: var(--button-color, #007bff);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: background 0.2s;
}

.prompts-page .btn-primary:hover {
  background: var(--hover-color, #0056b3);
}

.prompts-page .btn-primary:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.prompts-page .btn-secondary {
  padding: 0.7rem 1.5rem;
  background: white;
  color: #666;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s;
}

.prompts-page .btn-secondary:hover {
  background: #f5f5f5;
  border-color: #bbb;
}

@media (max-width: 768px) {
  .prompts-page {
    padding: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/PromptsPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;EACX,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,4CAA4C;EAC5C,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;EACxC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".prompts-page {\n  padding: 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.prompts-page .page-header {\n  margin-bottom: 1rem;\n}\n\n.prompts-page .page-header h1 {\n  margin: 0;\n  font-size: 1.8rem;\n  color: #333;\n}\n\n.prompts-page .section-description {\n  color: #666;\n  margin: 0 0 2rem 0;\n  font-size: 0.95rem;\n}\n\n.prompts-page .account-selector {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 2rem;\n  padding: 1rem;\n  background: #f8f9fa;\n  border-radius: 8px;\n}\n\n.prompts-page .account-selector label {\n  font-weight: 500;\n  color: #333;\n}\n\n.prompts-page .account-selector select {\n  flex: 1;\n  max-width: 400px;\n  padding: 0.75rem 1rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 0.95rem;\n  background: white;\n}\n\n.prompts-page .account-selector select:focus {\n  outline: none;\n  border-color: var(--button-color, #007bff);\n}\n\n.prompts-page .error-message {\n  background: #f8d7da;\n  color: #721c24;\n  padding: 1rem;\n  border-radius: 4px;\n  margin-bottom: 1rem;\n}\n\n.prompts-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.prompt-card {\n  background: white;\n  border-radius: 8px;\n  padding: 1.5rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.prompt-card-header {\n  margin-bottom: 0.5rem;\n}\n\n.prompt-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.prompt-card-header h3 {\n  margin: 0;\n  font-size: 1.1rem;\n  color: #333;\n}\n\n.prompt-card-title {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.prompt-card-status {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.operation-key {\n  font-family: monospace;\n  font-size: 0.8rem;\n  background: #e9ecef;\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  color: #666;\n}\n\n.status-toggle {\n  padding: 0.35rem 0.75rem;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  cursor: pointer;\n  border: none;\n  transition: all 0.2s;\n}\n\n.status-toggle.active {\n  background: #d4edda;\n  color: #155724;\n}\n\n.status-toggle.active:hover {\n  background: #c3e6cb;\n}\n\n.status-toggle.inactive {\n  background: #f8d7da;\n  color: #721c24;\n}\n\n.status-toggle.inactive:hover {\n  background: #f5c6cb;\n}\n\n.prompt-badge {\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.7rem;\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n.prompt-badge.custom {\n  background: #cce5ff;\n  color: #004085;\n}\n\n.prompt-badge.default {\n  background: #e9ecef;\n  color: #6c757d;\n}\n\n.prompt-card.disabled {\n  opacity: 0.6;\n}\n\n.prompt-card.disabled .prompt-card-header h3 {\n  color: #999;\n}\n\n.prompt-card-description {\n  color: #666;\n  font-size: 0.9rem;\n  margin: 0 0 1rem 0;\n}\n\n.prompt-buttons {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.btn-reset-prompt {\n  padding: 0.5rem 1rem;\n  background: #fff3cd;\n  color: #856404;\n  border: 1px solid #ffeeba;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.85rem;\n  transition: all 0.2s;\n}\n\n.btn-reset-prompt:hover {\n  background: #ffe69c;\n  border-color: #ffc107;\n}\n\n.btn-reset-prompt:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.default-prompt {\n  color: #888 !important;\n}\n\n.prompt-preview {\n  border-top: 1px solid #eee;\n  padding-top: 1rem;\n}\n\n.prompt-text {\n  background: #f8f9fa;\n  border-radius: 4px;\n  padding: 1rem;\n  margin-bottom: 1rem;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.prompt-text pre {\n  margin: 0;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  font-size: 0.8rem;\n  color: #555;\n  font-family: 'Consolas', 'Monaco', monospace;\n  line-height: 1.4;\n}\n\n.no-prompt {\n  color: #999;\n  font-style: italic;\n}\n\n.btn-edit-prompt {\n  padding: 0.5rem 1rem;\n  background: #f0f0f0;\n  color: #555;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.85rem;\n  transition: all 0.2s;\n}\n\n.btn-edit-prompt:hover {\n  background: #e5e5e5;\n  border-color: #ccc;\n}\n\n.prompt-editor {\n  border-top: 1px solid #eee;\n  padding-top: 1rem;\n}\n\n.prompt-editor textarea {\n  width: 100%;\n  padding: 1rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 0.85rem;\n  font-family: 'Consolas', 'Monaco', monospace;\n  line-height: 1.4;\n  resize: vertical;\n  min-height: 300px;\n}\n\n.prompt-editor textarea:focus {\n  outline: none;\n  border-color: var(--button-color, #007bff);\n}\n\n.prompt-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  margin-top: 1rem;\n}\n\n.prompts-page .btn-primary {\n  padding: 0.7rem 1.5rem;\n  background: var(--button-color, #007bff);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background 0.2s;\n}\n\n.prompts-page .btn-primary:hover {\n  background: var(--hover-color, #0056b3);\n}\n\n.prompts-page .btn-primary:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n.prompts-page .btn-secondary {\n  padding: 0.7rem 1.5rem;\n  background: white;\n  color: #666;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.2s;\n}\n\n.prompts-page .btn-secondary:hover {\n  background: #f5f5f5;\n  border-color: #bbb;\n}\n\n@media (max-width: 768px) {\n  .prompts-page {\n    padding: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
